export default {
    LOAD_STUDENT_COURSES_LIST_SUCCESS: 'LOAD_STUDENT_COURSES_LIST_SUCCESS',
    LOAD_STUDENT_COURSES_LIST_FAILURE: 'LOAD_STUDENT_COURSES_LIST_FAILURE',
    UNREGISTER_COURSE_SUCCESS: 'UNREGISTER_COURSE_SUCCESS'
};
